const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/quotes`,
    customers: `${API_URL}/customers`,
    statuses: `${API_URL}/quote-statuses`
};

export default apiUrls;
